export const getShowCustomTax = (country: string) => country === "US";
